import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';

// 全局状态管理工具
import registerCommonComponents from './common/registerCommonComponents'
// 注册UI组件
import registerUI from './common/registerUI'
// ConfigProvider 全局配置
import { ConfigProvider } from 'vant';

const app = createApp(App);
app.use(router);

// 注册UI组件
registerUI(app);
// 注册全局插件或组件
registerCommonComponents(app);
// ConfigProvider 全局配置
app.use(ConfigProvider);

app.mount('#app');


